import { useState } from "react";

const useModal = (data: IModalProps) => {
    const [modal, setModal] = useState(data)

    const show = (txt: string = 'Cargando') => setModal({ ...modal, active: true, txtMsg: txt });
    const hide = () => setModal({ ...modal, active: false });
 
    return {
        modal,
        show, 
        hide
    }
}

export { useModal }